module.exports = __webpack_public_path__ + "img/caret-down-fill.4a2339b0.svg";